export enum WidgetPreliminaryRiskAssessmentCheckedValueV0 {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
  NONE = 'NONE'
}
export interface WidgetPreliminaryRiskAssessmentPreviewV0 {
  id?: number,
  label: string;
  description?: string | null;
  uuid: string;
  help?: string | null;
  checked: WidgetPreliminaryRiskAssessmentCheckedValueV0;
  disabled?: boolean;
  editable?: boolean;
}
